import { ImageSizeWithOriginalInUriSchemaBuilder } from '../utils/image-size';

export enum ExperienceImageSizes {
  W384 = '384',
  W480 = '480',
  W640 = '640',
  W750 = '750',
  W1080 = '1080',
}

export enum MediaType {
  IMAGE = 'image',
  VIDEO = 'video',
}

export enum MediaLinkResolution {
  ORIGINAL = 'original',
  ADAPTATIVE = 'adaptative',
  '240p' = '240',
  '36Op' = '360',
  '480p' = '480',
  '540p' = '540',
  '640p' = '640',
  '720p' = '720',
  '1080p' = '1080',
}

export const ExperienceImageSizeWithOriginalInUriSchema = ImageSizeWithOriginalInUriSchemaBuilder(
  Object.values(ExperienceImageSizes),
);

export enum ExperienceKind {
  EXPERIENCE = 'experience',
  RESOURCE = 'resource',
}

export enum ExperienceVersion {
  LATEST = 'latest',
  PUBLISHED = 'published',
}

export const isExperienceVersion = (experienceVersion: string): experienceVersion is ExperienceVersion =>
  Object.values(ExperienceVersion).includes(experienceVersion as ExperienceVersion);

export enum ExperienceStatus {
  DRAFT = 'draft',
  PENDING = 'pending',
  PUBLISHED = 'published',
  UNPUBLISHED = 'unpublished',
}

export const isExperienceStatus = (experienceStatus: string): experienceStatus is ExperienceStatus =>
  Object.values(ExperienceStatus).includes(experienceStatus as ExperienceStatus);
